import React from 'react';
import { Platform, TouchableOpacityProps } from 'react-native';
import styled from 'styled-components/native';

import { H5 } from './Typography';
import IconBadge from './IconBadge';
import Colors from '../constants/Colors';
import { ButtonProps } from './Button';

const StyledView = styled.View`
  height: 36px;
  width: 36px;
`;

const StyledButton = styled.TouchableOpacity<{
  inverse?: boolean;
  isAdmin?: boolean;
}>`
  background-color: ${p =>
    p.isAdmin
      ? Colors.lightText
      : p.inverse
      ? Colors.lightText
      : Colors.primaryPurple};
  width: 36px;
  height: 36px;
  border-radius: 100px;
  align-items: center;
  justify-content: center;
  padding-top: ${Platform.OS === 'android' ? '0px' : '2px'};
` as React.FC<ProfileButtonMenuProps>;

const StyledH5 = styled(H5)`
  line-height: 22px;
`;

const StyledAvatar = styled.Image`
  height: 36px;
  width: 36px;
`;

export type ProfileButtonMenuProps = TouchableOpacityProps & {
  name: string;
  badgeNumber?: number;
  reference?: any;
  inverse?: boolean;
  isAdmin?: boolean;
};

const ProfileButtonMenu: React.FC<ProfileButtonMenuProps> = ({
  name,
  badgeNumber,
  reference,
  inverse,
  isAdmin,
  ...props
}) => {
  return (
    <StyledView>
      <StyledButton
        inverse={inverse}
        isAdmin={isAdmin}
        activeOpacity={0.7}
        onPress={props.onPress}
        ref={reference}
      >
        {isAdmin ? (
          <StyledAvatar source={require('../assets/icon-scientist.png')} />
        ) : (
          <StyledH5 center color={inverse ? 'dark' : 'light'}>
            {name.charAt(0)}
          </StyledH5>
        )}
      </StyledButton>
      {typeof badgeNumber === 'number' && badgeNumber > 0 && (
        <IconBadge value={badgeNumber} top={-7} right={-6} />
      )}
    </StyledView>
  );
};

export default ProfileButtonMenu;
